import { render, staticRenderFns } from "./DiagnosisCaseInform.vue?vue&type=template&id=a9ef95be&"
import script from "./DiagnosisCaseInform.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCaseInform.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisCaseInform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports